export default __webpack_public_path__ + "static/media/guide.7f4e2bb8.png";